import { baseResponseSchema } from 'services/api/api.types';
import { z } from 'zod/v4';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

export enum LossLimitationTypeCode {
  // net loss
  NLD = 'NLD',
  NLW = 'NLW',
  NLM = 'NLM',
  NLWR = 'NLWR',
  // time loss
  TLW = 'TLW',
  TLWR = 'TLWR',
}

const lossLimitationTypeCodeSchema = z.enum([
  LossLimitationTypeCode.NLD,
  LossLimitationTypeCode.NLW,
  LossLimitationTypeCode.NLM,
  LossLimitationTypeCode.NLWR,
  LossLimitationTypeCode.TLW,
  LossLimitationTypeCode.TLWR,
]);

const lossLimitationTypeSchema = z.object({
  code: lossLimitationTypeCodeSchema,
  description: z.string(),
  limitMin: z.number(),
  limitMax: z.number(),
});

const lossLimitationTypesResponseSchema = baseResponseSchema.extend({
  responseObject: z.array(lossLimitationTypeSchema),
});

type LossLimitationTypesIResponse = z.infer<
  typeof lossLimitationTypesResponseSchema
>;

type LossLimitationType = z.infer<typeof lossLimitationTypeSchema>;

type NormalizedLossLimitationTypes = Partial<
  Record<LossLimitationTypeCode, LossLimitationType>
>;

type TransformedLossLimitationTypesResponse = ReturnType<
  typeof transformLossLimitationTypesResponse
>;

/*-------------------------------------------------------------------------------------------------
 * transformer helper
 * -----------------------------------------------------------------------------------------------*/

const transformLossLimitationTypesResponse = (
  response: LossLimitationTypesIResponse,
) => {
  const normalized =
    response.responseObject.reduce<NormalizedLossLimitationTypes>(
      (acc, item) => {
        acc[item.code] = item;
        return acc;
      },
      {},
    );

  return {
    normalized,
    list: response.responseObject,
  };
};

export {
  lossLimitationTypesResponseSchema,
  transformLossLimitationTypesResponse,
};
export type {
  LossLimitationTypesIResponse,
  NormalizedLossLimitationTypes,
  TransformedLossLimitationTypesResponse,
};
